module.exports = __webpack_public_path__ + "img/logo_app_branco.e6595315.svg";